import React, { useState } from "react";

import { Box, TextField, Alert, Switch, Typography } from "@mui/material";
import {
	inputLabels,
	inputLabelsAR,
	inputsGuideText,
	InputValidation,
	shouldDisableVisibilityUpdate
} from "../../../utils/inputs";
import styled from "styled-components";
import FeatureGuide from "../../FeatureGuide";
import { LTR } from "../../Templates/WeddingTemplates/constants";

const TextInputWrapper = styled(Box)`
	display: flex;
	flex-direction: column;
	width: 90%;
	.MuiInputBase-multiline {
		padding: 0;
	}
	.MuiInputBase-inputMultiline {
		padding: 10px 15px;
	}
	.MuiAlert-message {
		word-break: break-all;
		white-space: normal;
	}
`;

const Text = ({
	value,
	onChange,
	fieldName,
	multiline = false,
	fieldValidationState,
	hidden,
	visibilityChange,
	dir
}: {
	value: string;
	onChange: (val: React.ChangeEvent<HTMLInputElement>) => void;
	fieldName: string;
	multiline?: boolean;
	fieldValidationState?: InputValidation;
	hidden?: boolean;
	visibilityChange?: (status: boolean, name: string) => void;
	dir?: string;
}) => {
	const guide = inputsGuideText[fieldName];
	const isComponent = typeof guide !== "string";
	const visibilityDisabled = shouldDisableVisibilityUpdate[fieldName];
	const [openGuide, setOpenGuide] = useState<string | null>(null);

	const handleGuideAction = (action: string) => {
		setOpenGuide(action);
	};

	return (
		<TextInputWrapper px={2}>
			{!visibilityDisabled && (
				<Box display={"flex"} justifyContent={"flex-end"} width={"100%"} my={1} alignItems={"center"}>
					<Typography>{hidden ? "Hidden" : "Visible"}</Typography>
					<Switch checked={!hidden} onChange={() => visibilityChange && visibilityChange(!hidden, fieldName)} />
				</Box>
			)}
			<TextField
				className={"guide_field_update"}
				placeholder={"Type here"}
				fullWidth
				value={value}
				onChange={onChange}
				label={dir === LTR ? inputLabels[fieldName] : inputLabelsAR[fieldName]}
				multiline={multiline}
				slotProps={{
					htmlInput: { maxLength: fieldValidationState?.max, minLength: fieldValidationState?.min },
					input: { dir: dir }
				}}
				{...(multiline ? { rows: 7 } : {})}
			/>
			{guide && <Box mt={2}>{isComponent ? guide(handleGuideAction) : <Alert severity="info">{guide}</Alert>}</Box>}
			{openGuide && <FeatureGuide title={"Location guide"} type={openGuide} onClose={() => setOpenGuide(null)} />}
		</TextInputWrapper>
	);
};
export default Text;
